module.exports = __webpack_public_path__ + "media/images/flags/BE-40c0e56ef3133ef5c26fd9d6011283cd.svg";